export default {
  filterArraysOfStrings (arraysOfStrings, searchTerm) {
    let filteredArr = arraysOfStrings;
    filteredArr = filteredArr.filter((item) => {
      // Ignore the Id and the full object
      const string = item.slice(1, 6).join('').toLowerCase();
      return string.indexOf(searchTerm) !== -1;
    });
    return filteredArr;
  }
};
